const STORAGE_KEY = "duty_check_job_v1";
const STALE_MS = 10 * 60 * 1000;

export function loadDutyCheckJob() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function saveDutyCheckJob(job) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(job));
    } catch {
        /* ignore quota errors */
    }
}

export function clearDutyCheckJob() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        /* ignore */
    }
}

export function isJobStale(job) {
    if (!job?.startedAt) return true;
    return Date.now() - job.startedAt > STALE_MS;
}
